import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyGrows from './components/WhyGrows';
import Packages from './components/Packages';
import Calculator from './components/Calculator';
import Activity from './components/Activity';
import Trust from './components/Trust';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0d1117]">
      <Navbar />
      <Hero />
      <WhyGrows />
      <Packages />
      <Calculator />
      <Activity />
      <Trust />
      <Footer />
    </div>
  );
}
